/* prettier-ignore */

import { Component, ElementRef, inject, Input, ViewChild, ViewEncapsulation } from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import "pannellum";

@Component({
  selector: "cicerone-image-360",
  standalone: true,
  imports: [
    IonicModule,
    TranslateModule
  ],
  templateUrl: "./image-360.component.html",
  styleUrls: ["./image-360.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class Image360Component {
  @ViewChild("panorama") panoramaEl!: ElementRef;
  @Input() dataPhoto: string;
  private modalController = inject(ModalController)
  public translate = inject(TranslateService)

  ngAfterViewInit() {
    this.initializePannellum();
  }

  initializePannellum() {
    (window as any).pannellum.viewer(this.panoramaEl.nativeElement, {
      type: "equirectangular",
      panorama: this.dataPhoto,
      autoLoad: true,
    });
  }

  dismissModal() {
    this.modalController.dismiss().catch(e => {
        console.warn("No modal found on dismiss")
    });
  }
}
